import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useAuth, useUser } from '@clerk/clerk-react';

import { MY_ONBOARDING_SESSION } from '../graphql/queries';
import { useAnalytics } from '../context/analytics';
import { tryFireDeferredInitiateCheckout } from '../utils/initiateCheckoutPixel';
import { useWaiting } from '../pages/welcome/useWaiting';

/**
 * Fires deferred onboarding conversion events (FB InitiateCheckout + GTM completed_onboarding)
 * when Clerk asfId arrives after the user left /welcome. WelcomeProvider handles the in-flow path.
 */
export function InitiateCheckoutTracker() {
  const { isSignedIn } = useAuth();
  const { user: clerkUser } = useUser();
  const asfId = clerkUser?.publicMetadata?.asfId as string | undefined;
  const { fbPixel, gtm } = useAnalytics();

  const { data } = useQuery(MY_ONBOARDING_SESSION, {
    skip: !isSignedIn,
    fetchPolicy: 'cache-and-network',
  });

  const session = data?.myOnboardingSession;
  // A held member's completed session is the waiting wizard, not onboarding (that is Meta `Schedule`).
  const { waiting, loading: accessLoading } = useWaiting({ skip: !isSignedIn });

  useEffect(() => {
    if (!asfId || !session || session.outcome !== 'COMPLETED') return;
    if (accessLoading || waiting) return;
    tryFireDeferredInitiateCheckout(asfId, session.id, fbPixel, gtm, session.completedAt);
  }, [asfId, session, fbPixel, gtm, accessLoading, waiting]);

  return null;
}
